<template src="./SettingMessageZaloComponent.html"></template>
<script>
import IconHome from "@/components/icons/IconHome.vue";
import BreadcrumbComponent from "@/components/breadcrumb/BreadcrumbComponent.vue";
import InputTextNormal from "@/components/inputs/input-text/normal/InputTextNormal.vue";
import SelectNormal from "@/components/inputs/select/normal/SelectNormal.vue";
import ButtonSearchComponent from "@/components/buttons/button-search/ButtonSearchComponent.vue";
import {computed, onMounted, reactive, ref} from "vue";
import CommonService from "@/services/common.service.ts";
import {AppConstant, CommonText} from "@/supports/app.constant.ts";
import {useAccountStore} from "@/stores/account.js";
import ProgressBarNormal from "@/components/progress-bar/normal/ProgressBarNormal.vue";
import InputPasswordNormal from "@/components/inputs/input-password/normal/InputPasswordNormal.vue";
import InputDateTimeNormal from "@/components/inputs/input-datetime/normal/InputDateTimeNormal.vue";
import ButtonBackComponent from "@/components/buttons/button-back/ButtonBackComponent.vue";
import ButtonAddComponent from "@/components/buttons/button-add/ButtonAddComponent.vue";
import ButtonNextComponent from "@/components/buttons/button-next/ButtonNextComponent.vue";
import IconCopy from "@/components/icons/IconCopy.vue";
import {useScreenSize} from "@/composable/useScreenSize.js";
import {useRouter} from "vue-router";
import InputCheckboxOne from "@/components/inputs/input-checkbox/normal/InputCheckboxNormal.vue";
import SelectCustom from "@/components/inputs/select/custom/SelectCustom.vue";
import PaginateComponent from "@/components/paginate/PaginateComponent.vue";
import ModalMessageZaloComponent from "@/components/modals/modal-message-zalo/ModalMessageZaloComponent.vue";
import ModalExportComponent from "@/components/modals/modal-export/ModalExportComponent.vue";
import LoadingComponent from "@/components/loading/LoadingComponent.vue";
import {useSyncZalo} from "@/stores/syncZalo.js";
export default {
  name: 'SettingMessageZaloComponent',
  computed: {
    AppConstant() {
      return AppConstant
    }
  },
  components: {
    LoadingComponent,
    ModalExportComponent,
    ModalMessageZaloComponent,
    PaginateComponent, SelectCustom, InputCheckboxOne,
    IconCopy,
    ButtonNextComponent, ButtonAddComponent, ButtonBackComponent, InputDateTimeNormal, InputPasswordNormal,
    ProgressBarNormal,
    ButtonSearchComponent,
    SelectNormal,
    InputTextNormal,
    BreadcrumbComponent,
    IconHome
  },
  setup() {
    const dataHeaderTable =  ref({
      messageName: {
        label: 'Tên tin nhắn',
        order: 1,
        width: '20%',
      },
      messageType: {
        label: 'Kiểu tin nhắn',
        order: 2,
        width: '5%',
      },
      messageDescription: {
        label: 'Mô tả ngắn gọn',
        order: 3,
        width: '20%',
      },
    })
    const labelButtonSearch = ref('Tìm kiếm')
    const labelButtonCreate = ref('Tạo tin nhắn')
    const urlOrigin = ref('/product/list/')
    const dataSearch = ref({
      name: {
        id: 'name',
        label: 'Tên tin nhắn',
        placeholder: 'Tên tin nhắn',
        value: '',
        required: false
      },
      type: {
        id: 'type',
        label: 'Kiểu tin nhắn',
        placeholder: 'Kiểu sản phẩm',
        value: '',
        required: false
      },
    })
    const checkAll = ref(false)
    const messageDetail = ref({})
    const checkItems = ref({})
    const listItemSelected = ref([])
    const isShowModal = ref(false)
    const listMessagesSelected = ref([])
    const isLoading = ref(false)
    const messError = ref('')
    const location = ref('Sản phẩm')
    const table = ref('product')
    const { widthScreen, isSmallScreen } = useScreenSize(1024);
    const selectAction = ref(CommonService.showDropdownAction(AppConstant.DROPDOWN_ACTION_PRODUCT))
    const selectLimitPage = ref(CommonService.showDropdownAction(AppConstant.DROPDOWN_ACTION_PAGE))

    const stateModal = reactive({
      modalMessageZalo: null,
    })
    const accountStore = useAccountStore()
    const syncZaloStore = useSyncZalo()
    const router = useRouter()

    onMounted(() => {
      stateModal.modalMessageZalo = new bootstrap.Modal('#modalMessageZalo', {})
      getListMessages(router.currentRoute.value.query.page ?? 1);
    });

    const listMessages = computed(() => {
      return syncZaloStore.messagesZalo;
    });
    const paginate = computed(() => {
      return syncZaloStore.paginate;
    });

    function emitPage(page) {
      getListMessages(page);
    }

    function getListMessages(page, take = 10) {
      const params = {
        id: accountStore.account.company.id,
        name: dataSearch.value.name.value,
        type: dataSearch.value.type.value,
        page: page,
        take: take,
      }
      const url = AppConstant.URL_API_LOCAL + 'api/v1/message-zalo/list';
      syncZaloStore.getListMessages(url, params);
    }

    function searchMessages() {
      getListMessages(1);
    }

    function onChange(value, name) {
      dataSearch.value[name].value = value;
    }

    async function actionLimitPage(key) {
      switch (parseInt(key)) {
        case AppConstant.LIMIT_PAGE_10:
          await getListMessages(1, AppConstant.LIMIT_PAGE_10);
          break;
        case AppConstant.LIMIT_PAGE_20:
          await getListMessages(1, AppConstant.LIMIT_PAGE_20);
          break;
        case AppConstant.LIMIT_PAGE_50:
          await getListMessages(1, AppConstant.LIMIT_PAGE_50);
          break;
      }
    }
    function eventClickShowModal(isShow) {
      if(isShow) {
        setTimeout(function () {
          isShowModal.value = false
          isLoading.value = false
          stateModal.modalMessageZalo.show()
        }, 1000);
        return;
      }
      stateModal.modalMessageZalo.hide()
    }

    function showMessageDetail(messageId) {
      messageDetail.value = syncZaloStore.messagesZalo.find((message) => message.id === messageId)
      isLoading.value = true
      isShowModal.value = true
    }

    function showErrorMessage(mess) {
      messError.value = mess
    }

    function removeError() {
      messError.value = ''
    }

    return {
      listMessages,
      dataHeaderTable,
      labelButtonSearch,
      labelButtonCreate,
      dataSearch,
      paginate,
      urlOrigin,
      checkAll,
      listItemSelected,
      checkItems,
      selectAction,
      selectLimitPage,
      listMessagesSelected,
      isLoading,
      messError,
      location,
      table,
      widthScreen,
      isSmallScreen,
      isShowModal,
      messageDetail,
      emitPage,
      searchMessages,
      onChange,
      eventClickShowModal,
      actionLimitPage,
      showErrorMessage,
      removeError,
      showMessageDetail,
      CommonText,
      CommonService,
    }
  },
}
</script>

<style lang="scss">
.dashboard-page {
  margin-top: 80px;
  margin-left: 265px;
  height: 100%;
  .title-page {
    padding: 15px 30px;
    background-color: #fff;
  }
  .container-fluid {
    padding-top: 30px;
    .card {
      margin-bottom: 30px;
      letter-spacing: .5px;
      box-shadow: 0 9px 20px rgba(46,35,94,.07);
      .card-body {
        padding: 30px;
        border-radius: 15px;
        background-color: #ffffff;
        td.message-name {
          max-width: 500px;
          p {
            overflow-y: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            line-clamp: 1;
            -webkit-box-orient: vertical;
            margin: 0;
            text-decoration: underline;
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>